import React from 'react'

import * as c from '../../../../common'
import * as r from '../../../../react-utils'

import * as MuiIcons from '@mui/icons-material'

//@ts-ignore
import gStyles from '../../../global.module.css'

//@ts-ignore
import styles from './Cost.module.css'

export interface ICost {
  customer: c.Customer
  name: keyof c.Customer
  value: string
}

export interface CostProps extends ICost {
  customerID: string
  isPDF: boolean
  onEfficiencyEdit: (field: string) => void
}

export default React.memo<CostProps>(
  ({ customer, customerID, isPDF, name: field, onEfficiencyEdit }) => {
    const notesRef = React.useRef<HTMLUListElement | null>(null)
    const [expandedVal, , expandedToggle] = r.useBool(false)
    const [isTruncating, isTruncatingSet] = React.useState(false)
    const [customerData] = r.useCustomer(customerID)

    const [enabledVal, enabledSet] = r.useCustomerField(
      customerID,
      (field + '_show') as c.CustomerField,
    )
    const enabledToggle = React.useCallback((): void => {
      enabledSet((curr) => (curr === 0 ? 1 : 0))
    }, [enabledSet])

    const handleEfficiencyEdit = React.useCallback(() => {
      onEfficiencyEdit(field)
    }, [field, onEfficiencyEdit])

    const notes = (
      customerData[(field + '_notes') as c.CustomerField] as string
    ).trim()

    const extraNotes = (
      (customerData[(field + '_extra_notes') as c.CustomerField] as string) ||
      ''
    ).trim()

    const allNotes = (notes + '\n' + extraNotes).trim()

    const wasExpandedRef = React.useRef(false)
    React.useEffect((): c.VoidFn => {
      const el = notesRef.current
      if (!el) return c.emptyFn

      if (!expandedVal) {
        const measure = () => {
          const { scrollHeight, clientHeight } = el
          isTruncatingSet(scrollHeight > clientHeight + 1)
        }
        if (wasExpandedRef.current) {
          const id = setTimeout(measure, 350)
          wasExpandedRef.current = false
          return (): void => clearTimeout(id)
        }
        measure()
      } else {
        wasExpandedRef.current = true
      }
      return c.emptyFn
    }, [allNotes, expandedVal])

    return (
      <tr className={expandedVal ? styles['root-expanded'] : styles['root']}>
        {!isPDF && (
          <td className={gStyles['cursor-pointer']} onClick={enabledToggle}>
            <input
              checked={enabledVal === 1}
              className={gStyles['cursor-pointer']}
              onChange={c.emptyFn}
              type="checkbox"
            />
          </td>
        )}

        <td className={styles['name']} onClick={enabledToggle}>
          {field.startsWith('custom_')
            ? (customer[
                (field + '_name') as keyof c.Customer
              ] as unknown as React.ReactElement)
            : c.getFieldLabel(field)}
        </td>

        <td
          className={
            !isPDF && isTruncating
              ? styles['notes-td-truncating']
              : styles['notes-td']
          }
          onClick={!isPDF && isTruncating ? expandedToggle : undefined}
        >
          <ul
            ref={notesRef}
            className={
              expandedVal ? styles['notes-ul-expanded'] : styles['notes-ul']
            }
          >
            {allNotes.split('\n').map((noteLine, i) => (
              <li className={styles['note-line']} key={field + i}>
                {noteLine}
              </li>
            ))}
          </ul>

          {!isPDF && isTruncating && (
            <div
              className={
                expandedVal
                  ? styles['notes-overlay-hidden']
                  : styles['notes-overlay']
              }
            />
          )}

          {!isPDF && isTruncating && (
            <MuiIcons.ChevronRight
              className={
                expandedVal
                  ? styles['chevron-expanded']
                  : styles['chevron-closed']
              }
              fontSize="small"
            />
          )}
        </td>

        {!isPDF && (
          <td
            className={gStyles['cursor-pointer']}
            onClick={handleEfficiencyEdit}
          >
            <MuiIcons.EditOutlined />
          </td>
        )}
      </tr>
    )
  },
)
